// hooks/category/useDeliveryFeeHandler.ts
import React from "react";

export const useDeliveryFeeHandler = (totalAmount: number, setDeliveryFee: React.Dispatch<React.SetStateAction<number>>) => {
  const handleDeliveryFeeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let value = e.target.value;

    if (Number(value) >= totalAmount) {
      e.target.value = value.slice(0, -1);
      return;
    }
    if (value === "") {
      setDeliveryFee(0);
      return;
    }
    if (value.length > 1 && value.startsWith("0")) {
      value = value.replace(/^0+/, "");
      e.target.value = value;
    }

    const numericValue = Number(value);
    if (numericValue >= 0 && numericValue < totalAmount) {
      setDeliveryFee(numericValue);
    } else {
      setDeliveryFee(0);
    }
  };

  return handleDeliveryFeeChange;
};